import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const OrderModal = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    content: '',
    payment_method: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.phone || !formData.address || !formData.content || !formData.payment_method) {
      toast.error('Kérjük, töltse ki az összes mezőt!');
      return;
    }

    setLoading(true);

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
      const response = await fetch(`${backendUrl}/api/orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Hiba történt a rendelés során');
      }

      toast.success('Rendelését sikeresen rögzítettük! Hamarosan keresni fogjuk.');
      
      // Reset form
      setFormData({
        name: '',
        phone: '',
        address: '',
        content: '',
        payment_method: ''
      });
      
      onClose();
    } catch (error) {
      console.error(error);
      toast.error('Sajnos nem sikerült elküldeni a rendelést. Kérjük, próbálja újra később.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handlePaymentChange = (value) => {
    setFormData({
      ...formData,
      payment_method: value
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[95vw] md:max-w-md max-h-[90vh] overflow-y-auto bg-card border-border text-card-foreground rounded-none p-4 md:p-6">
        <DialogHeader>
          <DialogTitle className="text-xl md:text-2xl font-serif text-primary text-center md:text-left break-words">Rendelés leadása</DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="name" className="text-foreground">Teljes Név *</Label>
            <Input
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Az Ön neve"
              required
              className="bg-background border-input text-foreground rounded-none text-base md:text-sm"
            />
          </div>

          <div>
            <Label htmlFor="phone" className="text-foreground">Telefonszám *</Label>
            <Input
              id="phone"
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+36 70 123 4567"
              required
              className="bg-background border-input text-foreground rounded-none text-base md:text-sm"
            />
          </div>

          <div>
            <Label htmlFor="address" className="text-foreground">Szállítási cím *</Label>
            <Input
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Város, utca, házszám"
              required
              className="bg-background border-input text-foreground rounded-none text-base md:text-sm"
            />
          </div>

          <div>
            <Label htmlFor="content" className="text-foreground">Rendelés tartalma *</Label>
            <Textarea
              id="content"
              name="content"
              value={formData.content}
              onChange={handleChange}
              placeholder="Pl.: 2db Gulyásleves, 1db Rántott hús..."
              required
              className="bg-background border-input text-foreground h-32 rounded-none text-base md:text-sm"
            />
          </div>

          <div>
            <Label htmlFor="payment_method" className="text-foreground">Fizetési mód *</Label>
            <Select onValueChange={handlePaymentChange} value={formData.payment_method}>
              <SelectTrigger className="w-full bg-background border-input text-foreground rounded-none text-base md:text-sm">
                <SelectValue placeholder="Válasszon fizetési módot" />
              </SelectTrigger>
              <SelectContent className="bg-popover text-popover-foreground border-border z-[60]">
                <SelectItem value="Készpénz" className="cursor-pointer hover:bg-accent hover:text-accent-foreground">Készpénz</SelectItem>
                <SelectItem value="Bankkártya" className="cursor-pointer hover:bg-accent hover:text-accent-foreground">Bankkártya (Futárnál)</SelectItem>
                <SelectItem value="SZÉP kártya" className="cursor-pointer hover:bg-accent hover:text-accent-foreground">SZÉP kártya</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <Button 
            type="submit" 
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold"
            disabled={loading}
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            {loading ? 'Küldés...' : 'Rendelés elküldése'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
